import { useEffect, useRef } from 'react'
import lottie from 'lottie-web'
import animationData from 'src/MEEESH_COIN.json'
import { cn } from '@/shared/lib/utils'

export default function CoinAnimation({ className }: { className?: string }) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: containerRef.current!,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData,
    })

    return () => {
      instance.destroy()
    }
  }, [])

  return (
    <div
      className={cn(
        'fixed inset-0 flex items-center justify-center',
        className,
      )}
    >
      <div ref={containerRef} style={{ width: 350, height: 350 }} />
    </div>
  )
}
